import FeedbackPage from '@/components/FeedbackPage'
import { getFeelingsFeedback } from '@/utils/feedbackContent'

export default function FeelingsFeedbackPage() {
  return <FeedbackPage {...getFeelingsFeedback()} />
}
